import { useEffect } from "react";
export default function Header() {
  useEffect(() => {
    const btn = document.getElementById('pda-hamburger');
    const menu = document.getElementById('pda-mobile-menu');
    if (!btn || !menu) return;
    const toggle = () => {
      const isOpen = menu.classList.toggle('open');
      btn.setAttribute('aria-expanded', String(isOpen));
    };
    btn.addEventListener('click', toggle);
    return () => btn.removeEventListener('click', toggle);
  }, []);
  const headerContent = `<style>
  #pda-site-header {
    position: sticky !important;
    top: 0 !important;
    z-index: 999 !important;
    background: rgba(248,245,242,.95) !important;
    backdrop-filter: blur(16px) !important;
    -webkit-backdrop-filter: blur(16px) !important;
    border-bottom: 1px solid #c7d1c7 !important;
    width: 100% !important;
    box-sizing: border-box !important;
  }
  #pda-site-header * {
    box-sizing: border-box !important;
    font-family: "Greycliff CF", Inter, ui-sans-serif, system-ui, sans-serif !important;
    -webkit-font-smoothing: antialiased !important;
  }
  .pda-nav-wrap {
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    gap: 20px !important;
    min-height: 70px !important;
    width: min(1180px, calc(100% - 40px)) !important;
    margin-inline: auto !important;
  }
  .pda-nav-wrap .pda-brand     { order: 1 !important; }
  .pda-nav-wrap .pda-nav-links { order: 2 !important; }
  .pda-nav-wrap .pda-nav-right { order: 3 !important; }
  .pda-brand {
    display: flex !important;
    align-items: center !important;
    gap: 10px !important;
    font-weight: 900 !important;
    font-size: 17px !important;
    letter-spacing: -.01em !important;
    color: #152937 !important;
    text-decoration: none !important;
    flex-shrink: 0 !important;
  }
  .pda-brand img {
    width: 36px !important; height: 36px !important;
    border-radius: 10px !important; display: block !important;
    object-fit: contain !important;
  }
  .pda-brand-name { color: #152937 !important; font-weight: 900 !important; font-size: 17px !important; }
  .pda-nav-links {
    display: flex !important; align-items: center !important;
    gap: 2px !important; list-style: none !important; margin: 0 !important; padding: 0 !important;
  }
  .pda-nav-links > a, .pda-has-dropdown > a {
    display: inline-flex !important; align-items: center !important; gap: 4px !important;
    padding: 8px 14px !important; border-radius: 999px !important; font-weight: 700 !important;
    font-size: 14.5px !important; color: #475c6b !important; text-decoration: none !important;
    transition: color .15s, background .15s !important; white-space: nowrap !important;
    cursor: pointer !important; border: none !important; background: transparent !important;
  }
  .pda-nav-links > a:hover, .pda-has-dropdown > a:hover {
    color: #152937 !important; background: #e8eee8 !important;
  }
  .pda-drop-arrow { font-size: 10px !important; opacity: .55 !important; color: #475c6b !important; }
  .pda-has-dropdown { position: relative !important; }
  .pda-dropdown {
    display: none !important; position: absolute !important;
    top: calc(100% + 8px) !important; left: 0 !important;
    min-width: 210px !important; background: #fbfaf8 !important;
    border: 1px solid #c7d1c7 !important; border-radius: 16px !important;
    box-shadow: 0px 8px 20px rgba(14,27,37,.14) !important;
    padding: 6px !important; z-index: 300 !important;
  }
  .pda-has-dropdown:hover .pda-dropdown { display: block !important; }
  .pda-dropdown a {
    display: block !important; padding: 9px 13px !important; border-radius: 10px !important;
    font-size: 14px !important; font-weight: 600 !important; color: #12212b !important;
    text-decoration: none !important; white-space: nowrap !important;
  }
  .pda-dropdown a:hover { background: #e8eee8 !important; color: #152937 !important; }
  .pda-dropdown-divider {
    height: 1px !important; background: #c7d1c7 !important;
    margin: 4px 8px !important; border: none !important;
  }
  .pda-nav-right {
    display: flex !important; align-items: center !important;
    gap: 12px !important; flex-shrink: 0 !important;
  }
  .pda-nav-cta {
    display: inline-flex !important; align-items: center !important;
    justify-content: center !important; padding: 10px 20px !important;
    border-radius: 999px !important; background: #d2562d !important;
    color: #fbfaf8 !important; font-weight: 800 !important; font-size: 14px !important;
    text-decoration: none !important; border: none !important; cursor: pointer !important;
    box-shadow: 0 6px 16px rgba(210,86,45,.22) !important;
    transition: opacity .18s, transform .18s !important; white-space: nowrap !important;
  }
  .pda-nav-cta:hover { opacity: .88 !important; transform: translateY(-1px) !important; color: #fbfaf8 !important; }
  .pda-hamburger {
    display: none !important; flex-direction: column !important; gap: 5px !important;
    background: transparent !important; border: none !important;
    padding: 8px !important; cursor: pointer !important; border-radius: 8px !important;
  }
  .pda-hamburger span {
    display: block !important; width: 22px !important; height: 2px !important;
    background: #152937 !important; border-radius: 2px !important;
  }
  .pda-hamburger:hover { background: #e8eee8 !important; }
  #pda-mobile-menu {
    display: none !important; border-top: 1px solid #c7d1c7 !important;
    background: #f8f5f2 !important; padding: 16px 20px 20px !important;
  }
  #pda-mobile-menu.open { display: block !important; }
  #pda-mobile-menu nav {
    display: flex !important; flex-direction: column !important;
    gap: 4px !important; margin-bottom: 16px !important;
  }
  #pda-mobile-menu nav a {
    padding: 12px 16px !important; border-radius: 10px !important;
    font-weight: 700 !important; font-size: 15px !important;
    color: #152937 !important; text-decoration: none !important;
  }
  #pda-mobile-menu nav a:hover { background: #e8eee8 !important; }
  #pda-mobile-menu .pda-mobile-sub {
    padding-left: 16px !important; border-left: 2px solid #c7d1c7 !important; margin: 4px 0 4px 16px !important;
  }
  #pda-mobile-menu .pda-mobile-sub a {
    font-size: 14px !important; font-weight: 600 !important; color: #475c6b !important; padding: 9px 12px !important;
  }
  #pda-mobile-menu .pda-nav-cta { width: 100% !important; justify-content: center !important; }
  @media (max-width: 768px) {
    .pda-nav-links { display: none !important; }
    .pda-hamburger { display: flex !important; }
    .pda-brand-name { display: none !important; }
  }
  @media (max-width: 400px) {
    .pda-nav-wrap { width: calc(100% - 28px) !important; }
  }
</style>

<header id="pda-site-header">
  <div class="pda-nav-wrap">

    <a class="pda-brand" href="https://pdaaustralia.com.au/" aria-label="PDA Australia home">
      <img src="https://pdaaustralia.com.au/img/aclc_college_logo.png"
           alt="PDA Australia logo" width="36" height="36"
           onerror="this.style.display='none'">
      <span class="pda-brand-name">PDA Australia</span>
    </a>

    <nav class="pda-nav-links" aria-label="Primary navigation">
      <a href="https://pdaaustralia.com.au/articles/">Articles</a>
      <div class="pda-has-dropdown">
        <a href="https://pdaaustralia.com.au/resources/">Free Resources <span class="pda-drop-arrow">&#9662;</span></a>
        <div class="pda-dropdown" role="menu">
          <a href="https://pdaaustralia.com.au/ndis/">NDIS &amp; PDA</a>
          <a href="https://pdaaustralia.com.au/schools/">PDA at School</a>
          <a href="https://pdaaustralia.com.au/adults/">PDA in Adults</a>
          <a href="https://pdaaustralia.com.au/girls/">Girls &amp; Women</a>
          <a href="https://pdaaustralia.com.au/support/">Support &amp; Services</a>
          <hr class="pda-dropdown-divider">
          <a href="https://pdaaustralia.com.au/resources/">Resources Library</a>
        </div>
      </div>
      <a href="https://pdaaustralia.com.au/start-here/">Start Here</a>
    </nav>

    <div class="pda-nav-right">
      <a class="pda-nav-cta" href="https://pdaaustralia.com.au/product/funded-ndis-guide-pda/">NDIS Funding Guide</a>
      <button id="pda-hamburger" class="pda-hamburger" aria-label="Toggle navigation" aria-expanded="false">
        <span></span><span></span><span></span>
      </button>
    </div>

  </div>

  <div id="pda-mobile-menu" aria-label="Mobile navigation">
    <nav>
      <a href="https://pdaaustralia.com.au/articles/">Articles</a>
      <a href="https://pdaaustralia.com.au/resources/">Free Resources</a>
      <div class="pda-mobile-sub">
        <a href="https://pdaaustralia.com.au/ndis/">NDIS &amp; PDA</a>
        <a href="https://pdaaustralia.com.au/schools/">PDA at School</a>
        <a href="https://pdaaustralia.com.au/adults/">PDA in Adults</a>
        <a href="https://pdaaustralia.com.au/girls/">Girls &amp; Women</a>
        <a href="https://pdaaustralia.com.au/support/">Support &amp; Services</a>
      </div>
      <a href="https://pdaaustralia.com.au/start-here/">Start Here</a>
    </nav>
    <a class="pda-nav-cta" href="https://pdaaustralia.com.au/product/funded-ndis-guide-pda/">NDIS Funding Guide</a>
  </div>
</header>`;
  return <div dangerouslySetInnerHTML={{
    __html: headerContent
  }} />;
}